// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  font-family: 'Montserrat', sans-serif !important;
}

/* Основные стили хедера */
.h-header-main {
  width: 100%;
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.06);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 24px;
  margin-bottom: 18px;
  min-height: 70px;
  box-sizing: border-box;
  position: relative;
}

.h-image {
  width: 50px;
  height: 50px;
}

.h-header-logo-area {
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

.h-logo-mark {
  display: flex;
  align-items: center;
  gap: 10px;
}

.h-logo-title {
  color: #002FA7;
  font-size: 19px;
  font-weight: 700;
  margin-left: 8px;
}

.h-logo-subtitle {
  color: #002FA7;
  font-size: 13px;
  font-weight: 400;
  margin-left: 8px;
}

/* Правая часть хедера */
.h-header-right-area {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-left: auto;
}

.h-header-theme-area {
  display: flex;
  align-items: center;
}

.h-header-profile-area {
  display: flex;
  align-items: center;
  position: relative;
}

/* Карточка профиля */
.h-profile-card {
  display: flex;
  align-items: center;
  gap: 8px;
  background: #d3dbff5d;
  border-radius: 16px;
  padding: 8px 18px;
  border: 1.5px solid rgba(99, 153, 254, 0.3);
  box-shadow: 0 4px 8px rgba(85, 105, 255, 0.15);
  cursor: pointer;
  transition: all 0.3s ease;
}

.h-profile-card:hover {
  background: #c5d0ff85;
  box-shadow: 0 6px 12px rgba(85, 105, 255, 0.2);
}

.h-profile-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: 8px;
}

.h-profile-name {
  font-size: 13px;
  color: #002FA7;
  font-weight: 500;
  margin-bottom: 2px;
}

.h-profile-info .h-profile-role {
  font-size: 12px;
  color: #002FA7;
  font-weight: 300;
}

.h-profile-arrow {
  font-size: 12px;
  color: #547ced;
  transition: transform 0.3s ease;
  margin-left: 5px;
}

.h-profile-arrow.h-rotated {
  transform: rotate(180deg);
}

/* Переключатель темы */
.h-theme-toggle {
  background: #d3dbff5d;
  border: 1.5px solid rgba(99, 153, 254, 0.3);
  box-shadow: 0 4px 8px rgba(85, 105, 255, 0.15);
  border-radius: 12px;
  padding: 10px 16px;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 500;
  backdrop-filter: blur(10px);
}

.h-theme-toggle:hover {
  background: #c5d0ff85;
  box-shadow: 0 6px 12px rgba(85, 105, 255, 0.2);
  transform: translateY(-1px);
}

.h-theme-toggle:active {
  transform: translateY(0);
}

.h-theme-toggle-inner {
  display: flex;
  align-items: center;
  gap: 10px;
}

.h-theme-icon {
  font-size: 18px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: #002FA7;
}

/* Выпадающее меню */
.h-profile-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 10px;
  background: white;
  border-radius: 16px;
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
  width: 260px;
  z-index: 4;
  overflow: hidden;
  border: 1px solid rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(20px);
  animation: h-fadeIn 0.2s ease-out;
}

@keyframes h-fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

.h-dropdown-user-info {
  padding: 16px 20px 20px;
  position: relative;
  overflow: hidden;
}

.h-dropdown-user-info .h-user-gradient-bg {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 100%;
  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);
  z-index: -1;
}

.h-dropdown-fullname {
  display: block;
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
  margin-bottom: 4px;
}

.h-dropdown-group {
  display: block;
  font-size: 13px;
  color: #d6e1ff;
  font-weight: 400;
}

.h-dropdown-menu {
  padding: 8px 0;
}

.h-dropdown-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 15px 20px;
  border: none;
  background: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
  font-size: 14px;
  color: #4664b5;
  text-align: left;
  font-weight: 400;
}

.h-dropdown-item:hover {
  background: rgba(102, 126, 234, 0.08);
  padding-left: 22px;
}

.h-dropdown-item.h-logout {
  color: #e53e3e;
  margin-top: 8px;
}

.h-dropdown-item.h-logout:hover {
  background: rgba(229, 62, 62, 0.08);
}

.h-dropdown-divider {
  height: 1px;
  background: rgba(102, 126, 234, 0.1);
  margin: 8px 0;
}

/* Светлая тема */
body.st-theme-light .h-dropdown-user-info .h-user-gradient-bg {
  background: linear-gradient(135deg, #d9e8fb 0%, #e9f0f7 100%);
}

body.st-theme-light .h-dropdown-fullname {
  color: #0d2e82;
}

body.st-theme-light .h-dropdown-group {
  color: #002FA7;
}

/* Медиа-запросы */
@media (max-width: 768px) {
  .h-header-main {
    flex-wrap: wrap;
  }
  
  .h-header-theme-area {
    margin-right: 16px;
  }
  
  .h-theme-toggle {
    padding: 8px 12px;
  }
  
  .h-theme-toggle-inner {
    gap: 0;
  }
  
  .h-header-right-area {
    order: 2;
  }
}

@media (max-width: 700px) {
  .h-header-main {
    padding: 8px 12px;
    flex-direction: column;
    gap: 12px;
  }
  
  .h-logo-title {
    font-size: 16px;
  }
  
  .h-logo-subtitle {
    font-size: 11px;
  }
  
  .h-profile-card {
    padding: 6px 12px;
  }
  
  .h-profile-dropdown {
    width: 240px;
    right: -10px;
  }
  
  .h-profile-info {
    align-items: flex-start;
  }
  
  .h-dropdown-item {
    padding: 9px 18px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .h-header-theme-area {
    margin-right: 12px;
  }
  
  .h-theme-toggle {
    padding: 6px 10px;
  }
  
  .h-theme-icon {
    font-size: 16px;
  }
  
  .h-logo-mark {
    flex-direction: column;
    text-align: center;
    gap: 5px;
  }
  
  .h-logo-title,
  .h-logo-subtitle {
    margin-left: 0;
  }
  
  .h-profile-name {
    font-size: 12px;
  }
  
  .h-dropdown-user-info {
    padding: 14px 16px 18px;
  }
  
  .h-dropdown-fullname {
    font-size: 14px;
  }
  
  .h-dropdown-group {
    font-size: 12px;
  }
}`, "",{"version":3,"sources":["webpack://./src/st-components/HeaderStudentStyle.css"],"names":[],"mappings":"AAEA;EACE,gDAAgD;AAClD;;AAEA,0BAA0B;AAC1B;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;EACxC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qBAAqB;EACrB,mBAAmB;EACnB,iBAAiB;EACjB,2CAA2C;EAC3C,8CAA8C;EAC9C,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,2CAA2C;EAC3C,8CAA8C;EAC9C,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,0CAA0C;EAC1C,2BAA2B;EAC3B,iCAAiC;AACnC;;AAEA;EACE;IACE,UAAU;IACV,wCAAwC;EAC1C;EACA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,6DAA6D;EAC7D,WAAW;AACb;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,6DAA6D;AAC/D;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,kBAAkB;AAClB;EACE;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,MAAM;EACR;;EAEA;IACE,QAAQ;EACV;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;IACjB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,kBAAkB;IAClB,QAAQ;EACV;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap');\n\n* {\n  font-family: 'Montserrat', sans-serif !important;\n}\n\n/* Основные стили хедера */\n.h-header-main {\n  width: 100%;\n  background: #fff;\n  border-radius: 20px;\n  box-shadow: 0 10px 40px rgba(0,0,0,0.06);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 8px 24px;\n  margin-bottom: 18px;\n  min-height: 70px;\n  box-sizing: border-box;\n  position: relative;\n}\n\n.h-image {\n  width: 50px;\n  height: 50px;\n}\n\n.h-header-logo-area {\n  display: flex;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.h-logo-mark {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.h-logo-title {\n  color: #002FA7;\n  font-size: 19px;\n  font-weight: 700;\n  margin-left: 8px;\n}\n\n.h-logo-subtitle {\n  color: #002FA7;\n  font-size: 13px;\n  font-weight: 400;\n  margin-left: 8px;\n}\n\n/* Правая часть хедера */\n.h-header-right-area {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-left: auto;\n}\n\n.h-header-theme-area {\n  display: flex;\n  align-items: center;\n}\n\n.h-header-profile-area {\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n/* Карточка профиля */\n.h-profile-card {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: #d3dbff5d;\n  border-radius: 16px;\n  padding: 8px 18px;\n  border: 1.5px solid rgba(99, 153, 254, 0.3);\n  box-shadow: 0 4px 8px rgba(85, 105, 255, 0.15);\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.h-profile-card:hover {\n  background: #c5d0ff85;\n  box-shadow: 0 6px 12px rgba(85, 105, 255, 0.2);\n}\n\n.h-profile-info {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-right: 8px;\n}\n\n.h-profile-name {\n  font-size: 13px;\n  color: #002FA7;\n  font-weight: 500;\n  margin-bottom: 2px;\n}\n\n.h-profile-info .h-profile-role {\n  font-size: 12px;\n  color: #002FA7;\n  font-weight: 300;\n}\n\n.h-profile-arrow {\n  font-size: 12px;\n  color: #547ced;\n  transition: transform 0.3s ease;\n  margin-left: 5px;\n}\n\n.h-profile-arrow.h-rotated {\n  transform: rotate(180deg);\n}\n\n/* Переключатель темы */\n.h-theme-toggle {\n  background: #d3dbff5d;\n  border: 1.5px solid rgba(99, 153, 254, 0.3);\n  box-shadow: 0 4px 8px rgba(85, 105, 255, 0.15);\n  border-radius: 12px;\n  padding: 10px 16px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  font-size: 14px;\n  font-weight: 500;\n  backdrop-filter: blur(10px);\n}\n\n.h-theme-toggle:hover {\n  background: #c5d0ff85;\n  box-shadow: 0 6px 12px rgba(85, 105, 255, 0.2);\n  transform: translateY(-1px);\n}\n\n.h-theme-toggle:active {\n  transform: translateY(0);\n}\n\n.h-theme-toggle-inner {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.h-theme-icon {\n  font-size: 18px;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  color: #002FA7;\n}\n\n/* Выпадающее меню */\n.h-profile-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 10px;\n  background: white;\n  border-radius: 16px;\n  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);\n  width: 260px;\n  z-index: 4;\n  overflow: hidden;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  backdrop-filter: blur(20px);\n  animation: h-fadeIn 0.2s ease-out;\n}\n\n@keyframes h-fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.h-dropdown-user-info {\n  padding: 16px 20px 20px;\n  position: relative;\n  overflow: hidden;\n}\n\n.h-dropdown-user-info .h-user-gradient-bg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 100%;\n  background: linear-gradient(135deg, #002FA7 0%, #5986f7 100%);\n  z-index: -1;\n}\n\n.h-dropdown-fullname {\n  display: block;\n  font-size: 15px;\n  font-weight: 600;\n  color: #ffffff;\n  margin-bottom: 4px;\n}\n\n.h-dropdown-group {\n  display: block;\n  font-size: 13px;\n  color: #d6e1ff;\n  font-weight: 400;\n}\n\n.h-dropdown-menu {\n  padding: 8px 0;\n}\n\n.h-dropdown-item {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 15px 20px;\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-size: 14px;\n  color: #4664b5;\n  text-align: left;\n  font-weight: 400;\n}\n\n.h-dropdown-item:hover {\n  background: rgba(102, 126, 234, 0.08);\n  padding-left: 22px;\n}\n\n.h-dropdown-item.h-logout {\n  color: #e53e3e;\n  margin-top: 8px;\n}\n\n.h-dropdown-item.h-logout:hover {\n  background: rgba(229, 62, 62, 0.08);\n}\n\n.h-dropdown-divider {\n  height: 1px;\n  background: rgba(102, 126, 234, 0.1);\n  margin: 8px 0;\n}\n\n/* Светлая тема */\nbody.st-theme-light .h-dropdown-user-info .h-user-gradient-bg {\n  background: linear-gradient(135deg, #d9e8fb 0%, #e9f0f7 100%);\n}\n\nbody.st-theme-light .h-dropdown-fullname {\n  color: #0d2e82;\n}\n\nbody.st-theme-light .h-dropdown-group {\n  color: #002FA7;\n}\n\n/* Медиа-запросы */\n@media (max-width: 768px) {\n  .h-header-main {\n    flex-wrap: wrap;\n  }\n  \n  .h-header-theme-area {\n    margin-right: 16px;\n  }\n  \n  .h-theme-toggle {\n    padding: 8px 12px;\n  }\n  \n  .h-theme-toggle-inner {\n    gap: 0;\n  }\n  \n  .h-header-right-area {\n    order: 2;\n  }\n}\n\n@media (max-width: 700px) {\n  .h-header-main {\n    padding: 8px 12px;\n    flex-direction: column;\n    gap: 12px;\n  }\n  \n  .h-logo-title {\n    font-size: 16px;\n  }\n  \n  .h-logo-subtitle {\n    font-size: 11px;\n  }\n  \n  .h-profile-card {\n    padding: 6px 12px;\n  }\n  \n  .h-profile-dropdown {\n    width: 240px;\n    right: -10px;\n  }\n  \n  .h-profile-info {\n    align-items: flex-start;\n  }\n  \n  .h-dropdown-item {\n    padding: 9px 18px;\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .h-header-theme-area {\n    margin-right: 12px;\n  }\n  \n  .h-theme-toggle {\n    padding: 6px 10px;\n  }\n  \n  .h-theme-icon {\n    font-size: 16px;\n  }\n  \n  .h-logo-mark {\n    flex-direction: column;\n    text-align: center;\n    gap: 5px;\n  }\n  \n  .h-logo-title,\n  .h-logo-subtitle {\n    margin-left: 0;\n  }\n  \n  .h-profile-name {\n    font-size: 12px;\n  }\n  \n  .h-dropdown-user-info {\n    padding: 14px 16px 18px;\n  }\n  \n  .h-dropdown-fullname {\n    font-size: 14px;\n  }\n  \n  .h-dropdown-group {\n    font-size: 12px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
